import { Box, Skeleton } from "@mantine/core";
import React from "react";

const FlaggedDataSkeleton = () => {
  return (
    <Box m="md">
      <Skeleton mt="md" mb="md" w={200} h={30} />
      <Skeleton h={190} />
    </Box>
  );
};

export default FlaggedDataSkeleton;
